import "./CaseStudyHowToQuit.scss";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import MediaBlock from "../MediaBlock/MediaBlock";
import BigDivider from "../BigDivider/BigDivider";
import useStore from "../../store";
import ImageRow from "../ImageRow/ImageRow";
import RoundedDivider from "../RoundedDivider/RoundedDivider";
import Quotes from "../Quotes/Quotes";
import ColorDivider from "../ColorDivider/ColorDivider";
import BigDividerVolta from "../BigDividerVolta/BigDividerVolta";
import MediaBlockAnimatedVolta from "../MediaBlockAnimatedVolta/MediaBlockAnimatedVolta";
import VoltaTitleBlock from "../VoltaTitleBlock/VoltaTitleBlock";
import VoltaMediaGrid from "../VoltaMediaGrid/VoltaMediaGrid";
import BigDividerVoltaAdvanced from "../BigDividerVoltaAdvanced/BigDividerVoltaAdvanced";
import BigDividerVoltaSplit from "../BigDividerVoltaSplit/BigDividerVoltaSplit";
import VoltaBarGraph from "../VoltaBarGraph/VoltaBarGraph";
import MetaTitleBlock from "../MetaTitleBlock/MetaTitleBlock";
import VideoPlayerBlock from "../VideoPlayerBlock/VideoPlayerBlock";
import ImageSequenceBlock from "../ImageSequenceBlock/ImageSequenceBlock";
import MetaAIMediaBlock from "../MetaAIMediaBlock/MetaAIMediaBlock";
import MetaAIMediaBlock2 from "../MetaAIMediaBlock2/MetaAIMediaBlock2";
import MediaGrid from "../MediaGrid/MediaGrid";
import HTQTitleBlock from "../HTQTitleBlock/HTQTitleBlock";

function CaseStudyHowToQuit(props) {
  const activeCaseStudy = useStore((state) => state.activeCaseStudy);

  const tl = useRef();
  const el = useRef();

  const sectionStart = useRef();
  const sectionEnd = useRef();

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    //console.log("active Case Study", activeCaseStudy);
    if (tl.current) tl.current.pause();
    // console.log("activeCaseStudy", activeCaseStudy, props.index);
    tl.current = gsap.timeline({
      onComplete: () => {
        ScrollTrigger.refresh();
      },
    });
    if (activeCaseStudy === null) {
      tl.current.call(() => {
        document.body.classList.remove("greyBackground");
      });
    }

    if (activeCaseStudy === props.index) {
      tl.current.call(() => {
        document.body.classList.add("greyBackground");
      });
      tl.current.to([el.current], {
        height: "auto",
        overflow: "unset",
        ease: "circ.in",
        duration: 0,
      });
      tl.current.to(props.el.current, {
        duration: 0.0,
        scrollTo: el.current.offsetTop - (window.innerHeight / 100) * 36,
        ease: "Power1.easeInOut",
      });
    } else {
      //tl.current.set([el.current], { height: "0" });
      if (
        el.current.offsetHeight > 0 &&
        props.el.current.scrollTop > el.current.offsetTop
      ) {
        tl.current.set(
          props.el.current,
          {
            scrollTo: props.el.current.scrollTop - el.current.offsetHeight,
          },
          0
        );
        tl.current.set(
          el.current,
          {
            height: 0,
            overflow: "hidden",
          },
          0
        );
      } else {
        tl.current.to(
          [el.current],
          {
            height: 0,
            ease: "circ.out",
            duration: 0.5,
            overflow: "hidden",
            // delay: 0.5,
          },
          0
        );
      }
    }
  }, [activeCaseStudy]);

  // useEffect(() => {
  //   console.log(isActive, props.index, activeCaseStudy);
  //   if (isActive && props.index === activeCaseStudy) {
  //     document.body.classList.add("greyBackground");
  //   } else {
  //     document.body.classList.remove("greyBackground");
  //   }
  // }, [isActive]);

  // useEffect(() => {
  //   ScrollTrigger.create({
  //     scroller: props.el.current,
  //     // markers: true,
  //     trigger: sectionStart.current,
  //     start: "top 22%",
  //     endTrigger: sectionEnd.current,
  //     end: "bottom top",
  //     invalidateOnRefresh: true,
  //     onToggle: (self) => {
  //       // console.log("toggled, isActive:", self.isActive);
  //       setIsActive(self.isActive);
  //     },
  //     onUpdate: (self) => {
  //       // console.log("progress:", self.progress.toFixed(3));
  //       //setProgress(parseFloat(self.progress.toFixed(3)));
  //     },
  //   });
  // }, []);

  return (
    <div
      id={"case-study-" + props.data.id}
      ref={el}
      className={`case-study-meta-how-to-quit`}
    >
      <div ref={sectionStart} className="section-start"></div>
      <VideoPlayerBlock
        data={props.data.blocks[0]}
        section={props.data.title}
        count={4}
        color={"black"}
        background={""}
        style={""}
        total={props.data.blocks.length + 1}
      />
      <HTQTitleBlock
        data={props.data.blocks[1]}
        section={props.data.title}
        count={2}
        background={"htqGrey"}
        color={"black"}
        total={props.data.blocks.length + 1}
        specialIndex={1}
      />
      <MediaBlock
        data={props.data.blocks[2]}
        section={props.data.title}
        count={3}
        color={"white"}
        background={"htqGrey"}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[3]}
        section={props.data.title}
        count={4}
        color={"white"}
        background={"htqGrey"}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[4]}
        count={5}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[5]}
        section={props.data.title}
        count={6}
        color={"white"}
        background={"htqGrey"}
        style={"full-bleed tight"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <HTQTitleBlock
        data={props.data.blocks[6]}
        section={props.data.title}
        count={7}
        background={"htqArmyGreen"}
        color={"black"}
        total={props.data.blocks.length + 1}
        specialIndex={2}
      />
      <MediaBlock
        data={props.data.blocks[7]}
        section={props.data.title}
        count={8}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[8]}
        background={"htqLightGreen"}
        color={"htqDarkArmyGreen"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[9]}
        background={"white"}
        color={"black"}
        count={10}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[10]}
        section={props.data.title}
        count={11}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[11]}
        count={12}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[12]}
        background={"htqLightPurple"}
        color={"htqDarkPurple"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[13]}
        background={"white"}
        color={"black"}
        count={14}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[14]}
        count={15}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[15]}
        section={props.data.title}
        count={16}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[16]}
        background={"htqLightArmyGreen"}
        color={"htqArmyGreen"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[17]}
        background={"white"}
        color={"black"}
        count={18}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[18]}
        section={props.data.title}
        count={19}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[19]}
        count={20}
        total={props.data.blocks.length + 1}
      />
      <HTQTitleBlock
        data={props.data.blocks[20]}
        section={props.data.title}
        count={21}
        background={"htqDarkBrown"}
        color={"black"}
        total={props.data.blocks.length + 1}
        specialIndex={3}
      />
      <MediaBlock
        data={props.data.blocks[21]}
        section={props.data.title}
        count={22}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[22]}
        background={"htqLightPink"}
        color={"htqDarkBrown"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[23]}
        section={props.data.title}
        count={24}
        color={"black"}
        background={""}
        style={"full-bleed tight"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[24]}
        count={25}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[25]}
        background={"white"}
        color={"black"}
        count={26}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[26]}
        section={props.data.title}
        count={27}
        color={"black"}
        background={"htqLightBlue"}
        style={"full"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[27]}
        background={"htqLight"}
        color={"black"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[28]}
        section={props.data.title}
        count={29}
        background={"htqLight"}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[29]}
        background={"white"}
        color={"black"}
        count={30}
        total={props.data.blocks.length + 1}
      />
      <MediaGrid
        data={props.data.blocks[30]}
        count={31}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[31]}
        section={props.data.title}
        count={32}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[32]}
        count={33}
        total={props.data.blocks.length + 1}
      />
      <BigDivider
        data={props.data.blocks[33]}
        background={"htqLightGrey2"}
        color={"htqDarkPurple2"}
        font={"HTQ"}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[34]}
        section={props.data.title}
        count={35}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[35]}
        count={36}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[36]}
        section={props.data.title}
        count={37}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[37]}
        count={38}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[38]}
        background={"white"}
        color={"black"}
        count={39}
        total={props.data.blocks.length + 1}
      />
      <HTQTitleBlock
        data={props.data.blocks[39]}
        section={props.data.title}
        count={40}
        background={"htqDarkArmyGreen"}
        color={"black"}
        total={props.data.blocks.length + 1}
        specialIndex={4}
      />
      <MediaBlock
        data={props.data.blocks[40]}
        section={props.data.title}
        count={41}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[41]}
        section={props.data.title}
        count={42}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[42]}
        section={props.data.title}
        count={43}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[43]}
        section={props.data.title}
        count={44}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <HTQTitleBlock
        data={props.data.blocks[44]}
        section={props.data.title}
        count={45}
        background={"htqOrange"}
        color={"black"}
        total={props.data.blocks.length + 1}
        specialIndex={5}
      />
      <MediaBlock
        data={props.data.blocks[45]}
        section={props.data.title}
        count={46}
        background={""}
        color={"black"}
        style={"full"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <ImageRow
        data={props.data.blocks[46]}
        count={47}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[47]}
        section={props.data.title}
        count={48}
        background={""}
        color={"white"}
        style={"full"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <Quotes
        data={props.data.blocks[48]}
        background={"beige"}
        color={"black"}
        highlight={"htqOrange"}
        count={49}
        total={props.data.blocks.length + 1}
      />

      <div ref={sectionEnd} className="section-end"></div>
    </div>
  );
}

export default CaseStudyHowToQuit;
